import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-icons/font/bootstrap-icons.css'
import './App.css'
import NavBar from 'NavBar'
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import BlockDiagram from 'BlockDiagram'
import Parameters from 'Parameters'
import TimingDiagram from 'TimingDiagram'
import RegisterMap from 'RegisterMap'
import Documents from 'Documents'
import Home from 'Home'
import Simulation from 'Simulation';

import { Settings } from 'Settings'

import { TYPE } from 'configuration'

function App() {
  return (
		<Settings>
			<Router className="App" basename={`/${TYPE}/`}>
				<NavBar />
				<Routes>
					<Route index path="/" element={<Home />} />
					<Route path="/block-diagram/" element={<BlockDiagram />} />
					<Route path="/parameters/" element={<Parameters />} />
					<Route path="/timing-diagram/" element={<TimingDiagram />} />
					<Route path="/register-map/" element={<RegisterMap />} />
					<Route path="/simulation/" element={<Simulation />} />
					<Route path="/documents/" element={<Documents />} />
				</Routes>
			</Router>
		</Settings>
  );
}

export default App;
